import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PolicyFloodDto } from "../../../model/PolicyFloodDto";
import { PolicyFloodSectionDto } from "../../../model/PolicyFloodSectionDto";
import { RootState } from "../../../../shared/store";
import { CustomerPolicyDetailLabels as cstPolicyUnderwritingLabel } from '../../../../shared/util/label';
import { Checkbox, Column, Row, Select } from "../../../../components";
import DatePicker from "react-datepicker";
import { CommonUtility } from "../../../../Services/CommonUtility";
import { useDispatch } from "react-redux";
import { updateSelectedPolicyDetails, updateLocationDetails, updateSelectedLOBDetails } from "../../../customer-slice/Customer-slice";
import { uuid } from "../../../../shared/util/uuid";
import { CustomerPolicyDetails as cstPolicyDetails } from '../../../../shared/util/constant'
import "./CustomerPolicyUnderwriting.scss";
import * as constant from '../../../../shared/util/constant';

export interface ICustomerEditPolicyFloodUnderwriting { 
    tabIndex?: number;
    validationErrors?: any;
}

const CustomerEditPolicyFloodUnderwriting: React.FunctionComponent<ICustomerEditPolicyFloodUnderwriting> = (props) => {
    let tbIndex = props.tabIndex;
    const { validationErrors } = props;
    const [formValidation, setFormValidation] = useState<any>({});
    const dispatch = useDispatch();
    const policyId = useSelector((state: RootState) => state.customerSlice.policyId);
    const polEventId = useSelector((state: RootState) => state.customerSlice.polEventId);
    const policyDetailKey = CommonUtility.getPolicyDetailKey(policyId, polEventId);
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice);
    const policyDetails = customerpolicyDetail.selectedPolicyDetails?.[policyDetailKey];
    // Get selected location from Redux
    const selectedLocationDetails = useSelector((state: RootState) => state.customerSlice.selectedLocationDetails);
    
    const floodOccupancyTypeList = useSelector((state: RootState) => state.LookupState.floodOccupancyTypeList);
    const basementTypeList = useSelector((state: RootState) => state.LookupState.basementTypeList);
    const numberOfFloorsTypeList = useSelector((state: RootState) => state.LookupState.numberOfFloorsTypeList);
    const contentLocationTypeList = useSelector((state: RootState) => state.LookupState.contentLocationTypeList);
    const ratingTypeList = useSelector((state: RootState) => state.LookupState.ratingTypeList);
    const nearestShoreTypeList = useSelector((state: RootState) => state.LookupState.nearestShoreTypeList);
    const elevatedFoundationTypeList = useSelector((state: RootState) => state.LookupState.elevatedFoundationTypeList);
    const elevatedMaterialTypeList = useSelector((state: RootState) => state.LookupState.elevatedMaterialTypeList);
    const enclosedForOtherPurposeTypeList = useSelector((state: RootState) => state.LookupState.enclosedForOtherPurposeTypeList);
    
    const floodOccupancyTypeOptions = [...floodOccupancyTypeList];
    const basementTypeOptions = [...basementTypeList]; 
    const numberOfFloorsTypeOptions = [...numberOfFloorsTypeList];
    const contentLocationTypeOptions = [...contentLocationTypeList];
    const ratingTypeOptions = [...ratingTypeList];
    const nearestShoreTypeOptions = [...nearestShoreTypeList];
    const elevatedFoundationTypeOptions = [...elevatedFoundationTypeList];
    const elevatedMaterialTypeOptions = [...elevatedMaterialTypeList];
    const enclosedForOtherPurposeTypeOptions = [...enclosedForOtherPurposeTypeList];

    const emptyFlood: PolicyFloodDto = {
        id: uuid(),
        polId: policyId,
        polEventId: polEventId,
        effDate: new Date(),
        statusTypeId: constant.StatusTypeIds.ADD,
        occupancyTypeId: null,
        basementTypeId: null,
        numberOfFloorsTypeId: null,
        isPrimaryResident: false,
        isCourseOfConstruction: false,
        isOwnedByState: false,
        replaceCost: null,
        isCondoCoverageForUnit: false,
        condoNoOfUnits: null,
        isHighRise: false,
        isBldgElevated: false,
        contentLocationTypeId: null,
        isContentHouseHold: false,
        mobileParkConstructionDate: null,
        constructionDate: null,
        improvementDate: null,
        bldgDiagramNum: null,
        lowestAdjGrade: null,
        lowestFloorElev: null,
        baseFloorElev: null,
        isBldgFloodProof: false,
        ratingTypeId: null
    };

    const emptyFloodSection: PolicyFloodSectionDto = {
        id: uuid(),
        polId: policyId,
        polEventId: polEventId,
        effDate: new Date(),
        statusTypeId: constant.StatusTypeIds.ADD,
        diagramNumber: null,
        nearestShoreTypeId: null,
        elevatedFoundationTypeId: null,
        elevatedMaterialTypeId: null,
        enclosedForOtherPurposeTypeId: null,
        enclosedFloorType: null,
        hasBasementEquip: false,
        hasBaseEquipmentFurnace: false,
        hasBaseEquipmentWaterHeater: false,
        hasBaseEquipmentElevator: false,
        hasBaseEquipmentHeatPump: false,
        hasBaseEquipmentFuelTank: false,
        hasBaseEquipmentWasherDryer: false,
        hasBaseEquipmentAirConditioner: false,
        hasBaseEquipmentCistern: false,
        hasBaseEquipmentFoodFreezer: false,
        hasBaseEquipmentOther: false,
        isGarageAttached: false,
        hasGarageEquipmentFurnace: false,
        hasGarageEquipmentWaterHeater: false,
        hasGarageEquipmentElevator: false,
        hasGarageEquipmentHeatPump: false,
        hasGarageEquipmentFuelTank: false,
        hasGarageEquipmentWasherDryer: false,
        hasGarageEquipmentAirConditioner: false,
        hasGarageEquipmentCistern: false,
        hasGarageEquipmentFoodFreezer: false,
        hasGarageEquipmentOther: false,
        hasElevatedEquip: false,
        hasElevatedEquipmentFurnace: false,
        hasElevatedEquipmentWaterHeater: false,
        hasElevatedEquipmentElevator: false,
        hasElevatedEquipmentHeatPump: false,
        hasElevatedEquipmentFuelTank: false,
        hasElevatedEquipmentWasherDryer: false,
        hasElevatedEquipmentAirConditioner: false,
        hasElevatedEquipmentCistern: false,
        hasElevatedEquipmentFoodFreezer: false,
        hasElevatedEquipmentOther: false,
        isEnclosedFloor: false,
        enclosedSize: null,
        isElevatedMaterial: false,
        isEnclosedWithOpening: false,
        isEnclosedWithAreaFinished: false
    };

    const numberFields = [
        'replaceCost', 'condoNoOfUnits', 'lowestAdjGrade', 'lowestFloorElev', 'baseFloorElev', 'enclosedSize'
    ];

    // Sync validation errors from props to local state (must be before early return)
    useEffect(() => {
        if (validationErrors) {
            setFormValidation(validationErrors);
        }
    }, [validationErrors]);

    if (!selectedLocationDetails) {
        return <div className="no-location-message">{cstPolicyDetails.NO_LOCATION_SELECTED}</div>;
    }

    // Check if location is new and unsaved (has temporary UUID, not saved to DB yet)
    if (selectedLocationDetails.isNewUnsaved === true) {
        return <div className="no-location-message">{cstPolicyDetails.LOCATION_NOT_SAVED}</div>;
    }

    // Get first policy flood from location, or create new one with correct IDs
    const policyFlood: PolicyFloodDto = selectedLocationDetails.policyFloods && selectedLocationDetails.policyFloods.length > 0
        ? selectedLocationDetails.policyFloods[0]
        : {
            ...emptyFlood,
            lobId: customerpolicyDetail.selectedLOBDetails?.id,
            locId: selectedLocationDetails?.id
        };

    // Get first policy flood section from location, or create new one with correct IDs
    const policyFloodSection: PolicyFloodSectionDto = selectedLocationDetails.policyFloodSections && selectedLocationDetails.policyFloodSections.length > 0
        ? selectedLocationDetails.policyFloodSections[0]
        : {
            ...emptyFloodSection,
            lobId: customerpolicyDetail.selectedLOBDetails?.id,
            locId: selectedLocationDetails?.id
        };


    const updateLocationFlood = (updatedFlood: PolicyFloodDto) => {
        if (!selectedLocationDetails) return;

        // Ensure lobId and locId are set
        if (!updatedFlood.lobId) {
            updatedFlood.lobId = customerpolicyDetail.selectedLOBDetails?.id;
        }
        if (!updatedFlood.locId) {
            updatedFlood.locId = selectedLocationDetails?.id;
        }

        let updatedPolicyFloods;
        if (selectedLocationDetails.policyFloods && selectedLocationDetails.policyFloods.length > 0) {
            updatedPolicyFloods = [updatedFlood, ...selectedLocationDetails.policyFloods.slice(1)];
        } else {
            updatedPolicyFloods = [updatedFlood];
        }
        
        const updatedLocation = { ...selectedLocationDetails, policyFloods: updatedPolicyFloods };
        dispatch(updateLocationDetails(updatedLocation));

        const selectedLOB = customerpolicyDetail.selectedLOBDetails;
        if (selectedLOB && selectedLOB.policyLocations) {
            const updatedLocations = selectedLOB.policyLocations.map(loc =>
                loc.id === updatedLocation.id ? updatedLocation : loc
            );
            const updatedLOB = { ...selectedLOB, policyLocations: updatedLocations };
            dispatch(updateSelectedLOBDetails(updatedLOB));

            if (policyDetails && policyDetails.policyLineOfBusinesses) {
                const updatedLOBs = policyDetails.policyLineOfBusinesses.map(lob =>
                    lob.id === updatedLOB.id ? updatedLOB : lob
                );
                const updatedPolicyDetails = { ...policyDetails, policyLineOfBusinesses: updatedLOBs };
                dispatch(updateSelectedPolicyDetails({
                    policyId,
                    polEventId,
                    policyDetails: updatedPolicyDetails
                }));
            }
        }
    };

    const updateLocationFloodSection = (updatedFloodSection: PolicyFloodSectionDto) => {
        if (!selectedLocationDetails) return;

        // Ensure lobId and locId are set
        if (!updatedFloodSection.lobId) {
            updatedFloodSection.lobId = customerpolicyDetail.selectedLOBDetails?.id;
        }
        if (!updatedFloodSection.locId) {
            updatedFloodSection.locId = selectedLocationDetails?.id;
        }

        let updatedPolicyFloodSections;
        if (selectedLocationDetails.policyFloodSections && selectedLocationDetails.policyFloodSections.length > 0) {
            updatedPolicyFloodSections = [updatedFloodSection, ...selectedLocationDetails.policyFloodSections.slice(1)];
        } else {
            updatedPolicyFloodSections = [updatedFloodSection];
        }
        
        const updatedLocation = { ...selectedLocationDetails, policyFloodSections: updatedPolicyFloodSections };
        dispatch(updateLocationDetails(updatedLocation));

        const selectedLOB = customerpolicyDetail.selectedLOBDetails;
        if (selectedLOB && selectedLOB.policyLocations) {
            const updatedLocations = selectedLOB.policyLocations.map(loc =>
                loc.id === updatedLocation.id ? updatedLocation : loc
            );
            const updatedLOB = { ...selectedLOB, policyLocations: updatedLocations };
            dispatch(updateSelectedLOBDetails(updatedLOB));

            if (policyDetails && policyDetails.policyLineOfBusinesses) {
                const updatedLOBs = policyDetails.policyLineOfBusinesses.map(lob =>
                    lob.id === updatedLOB.id ? updatedLOB : lob
                );
                const updatedPolicyDetails = { ...policyDetails, policyLineOfBusinesses: updatedLOBs };
                dispatch(updateSelectedPolicyDetails({
                    policyId,
                    polEventId,
                    policyDetails: updatedPolicyDetails
                }));
            }
        }
    };

    const onFloodFieldChange = (field: keyof PolicyFloodDto, value: any) => {
        if (!policyFlood) return;
        let newValue = value;
        if (numberFields.includes(field as string)) {
            newValue = value === "" ? null : value;
        }
        if (
            field === "mobileParkConstructionDate" ||
            field === "constructionDate" ||
            field === "improvementDate"
        ) {
            newValue = value ? CommonUtility.datetimeToDateOnly(value) : undefined;
        }

        const updatedFlood = { ...policyFlood, [field]: newValue };
        updateLocationFlood(updatedFlood);
    };

    const onFloodSectionFieldChange = (field: keyof PolicyFloodSectionDto, value: any) => {
        if (!policyFloodSection) return;
        let newValue = value;
        if (numberFields.includes(field as string)) {
            newValue = value === "" ? null : value;
        }

        const updatedFloodSection = { ...policyFloodSection, [field]: newValue };
        updateLocationFloodSection(updatedFloodSection);
    };

    return (
        <div className="additional-interest-form" style={{ marginBottom: 12 }}>
            {/* Row 1 - Dropdowns */}
            <Row>
                <Column lg={3} md={3}>
                    <Select
                        id="occupancyTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.OCCUPANCY}
                        options={floodOccupancyTypeOptions}
                        defaultSelected={floodOccupancyTypeOptions.filter(opt => opt.value === policyFlood?.occupancyTypeId)}
                        onChange={values => onFloodFieldChange('occupancyTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.OCCUPANCY}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="basementTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.BASEMENT}
                        options={basementTypeOptions}
                        defaultSelected={basementTypeOptions.filter(opt => opt.value === policyFlood?.basementTypeId)}
                        onChange={values => onFloodFieldChange('basementTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.BASEMENT}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="numberOfFloorsTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.NUMBER_OF_FLOORS}
                        options={numberOfFloorsTypeOptions}
                        defaultSelected={numberOfFloorsTypeOptions.filter(opt => opt.value === policyFlood?.numberOfFloorsTypeId)}
                        onChange={values => onFloodFieldChange('numberOfFloorsTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.NUMBER_OF_FLOORS}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="contentLocationTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.CONTENT_LOCATION_TYPE}
                        options={contentLocationTypeOptions}
                        defaultSelected={contentLocationTypeOptions.filter(opt => opt.value === policyFlood?.contentLocationTypeId)}
                        onChange={values => onFloodFieldChange('contentLocationTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.CONTENT_LOCATION_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
            </Row>
            
            {/* Row 2 - Number inputs and Rating dropdown */}
            <Row>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="replaceCost" className="mb-3" label={cstPolicyUnderwritingLabel.REPLACE_COST}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="replaceCost"
                            placeholder={cstPolicyUnderwritingLabel.REPLACE_COST}
                            value={policyFlood?.replaceCost || ''}
                            onChange={e => onFloodFieldChange('replaceCost', e.currentTarget.value)}
                            isInvalid={formValidation[`replaceCost_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`replaceCost_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="condoNoOfUnits" className="mb-3" label={cstPolicyUnderwritingLabel.CONDO_NO_OF_UNITS}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="condoNoOfUnits"
                            placeholder={cstPolicyUnderwritingLabel.CONDO_NO_OF_UNITS}
                            value={policyFlood?.condoNoOfUnits || ''}
                            onChange={e => onFloodFieldChange('condoNoOfUnits', e.currentTarget.value)}
                            isInvalid={formValidation[`condoNoOfUnits_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`condoNoOfUnits_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="ratingTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.RATING_TYPE}
                        options={ratingTypeOptions}
                        defaultSelected={ratingTypeOptions.filter(opt => opt.value === policyFlood?.ratingTypeId)}
                        onChange={values => onFloodFieldChange('ratingTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.RATING_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="bldgDiagramNum" className="mb-3" label={cstPolicyUnderwritingLabel.BLDG_DIAGRAM_NUM}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="bldgDiagramNum"
                            placeholder={cstPolicyUnderwritingLabel.BLDG_DIAGRAM_NUM}
                            value={policyFlood?.bldgDiagramNum || ''}
                            onChange={e => onFloodFieldChange('bldgDiagramNum', e.currentTarget.value)}
                            maxLength={5}
                            isInvalid={formValidation[`bldgDiagramNum_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`bldgDiagramNum_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
            </Row>
            
            {/* Row 3 - Elevation fields + date */}
            <Row>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="lowestAdjGrade" className="mb-3" label={cstPolicyUnderwritingLabel.LOWEST_ADJ_GRADE}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="lowestAdjGrade"
                            placeholder={cstPolicyUnderwritingLabel.LOWEST_ADJ_GRADE}
                            value={policyFlood?.lowestAdjGrade || ''}
                            onChange={e => onFloodFieldChange('lowestAdjGrade', e.currentTarget.value)}
                            isInvalid={formValidation[`lowestAdjGrade_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`lowestAdjGrade_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="lowestFloorElev" className="mb-3" label={cstPolicyUnderwritingLabel.LOWEST_FLOOR_ELEV}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="lowestFloorElev"
                            placeholder={cstPolicyUnderwritingLabel.LOWEST_FLOOR_ELEV}
                            value={policyFlood?.lowestFloorElev || ''}
                            onChange={e => onFloodFieldChange('lowestFloorElev', e.currentTarget.value)}
                            isInvalid={formValidation[`lowestFloorElev_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`lowestFloorElev_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="baseFloorElev" className="mb-3" label={cstPolicyUnderwritingLabel.BASE_FLOOR_ELEV}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="baseFloorElev"
                            placeholder={cstPolicyUnderwritingLabel.BASE_FLOOR_ELEV}
                            value={policyFlood?.baseFloorElev || ''}
                            onChange={e => onFloodFieldChange('baseFloorElev', e.currentTarget.value)}
                            isInvalid={formValidation[`baseFloorElev_${policyFlood?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`baseFloorElev_${policyFlood?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>
                            {cstPolicyUnderwritingLabel.MOBILE_PARK_CONSTRUCTION_DATE}
                        </InputGroup.Text>
                        <DatePicker
                            dateFormatCalendar="LLLL yyyy"
                            tabIndex={tbIndex++}
                            dropdownMode="scroll"
                            selected={CommonUtility.datetimeToDateOnlyObject(policyFlood?.mobileParkConstructionDate)}
                            onChange={date => onFloodFieldChange('mobileParkConstructionDate', date)}
                            className="form-control"
                        />
                        <InputGroup.Text>
                            <i className="bi bi-calendar3"></i>
                        </InputGroup.Text>
                    </InputGroup>
                </Column>
            </Row>
            
            {/* Row 4 - Date fields + flood section */}
            <Row>
                <Column lg={3} md={3}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>
                            {cstPolicyUnderwritingLabel.CONSTRUCTION_DATE}
                        </InputGroup.Text>
                        <DatePicker
                            dateFormatCalendar="LLLL yyyy"
                            tabIndex={tbIndex++}
                            dropdownMode="scroll"
                            selected={CommonUtility.datetimeToDateOnlyObject(policyFlood?.constructionDate)}
                            onChange={date => onFloodFieldChange('constructionDate', date)}
                            className="form-control"
                        />
                        <InputGroup.Text>
                            <i className="bi bi-calendar3"></i>
                        </InputGroup.Text>
                    </InputGroup>
                </Column>
                <Column lg={3} md={3}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>
                            {cstPolicyUnderwritingLabel.IMPROVEMENT_DATE}
                        </InputGroup.Text>
                        <DatePicker
                            dateFormatCalendar="LLLL yyyy"
                            tabIndex={tbIndex++}
                            dropdownMode="scroll"
                            selected={CommonUtility.datetimeToDateOnlyObject(policyFlood?.improvementDate)}
                            onChange={date => onFloodFieldChange('improvementDate', date)}
                            className="form-control"
                        />
                        <InputGroup.Text>
                            <i className="bi bi-calendar3"></i>
                        </InputGroup.Text>
                    </InputGroup>
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="diagramNumber" className="mb-3" label={cstPolicyUnderwritingLabel.DIAGRAM_NUMBER}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="diagramNumber"
                            placeholder={cstPolicyUnderwritingLabel.DIAGRAM_NUMBER}
                            value={policyFloodSection?.diagramNumber || ''}
                            onChange={e => onFloodSectionFieldChange('diagramNumber', e.currentTarget.value)}
                            maxLength={12}
                            isInvalid={formValidation[`diagramNumber_${policyFloodSection?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`diagramNumber_${policyFloodSection?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="nearestShoreTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.NEAREST_SHORE_TYPE}
                        options={nearestShoreTypeOptions}
                        defaultSelected={nearestShoreTypeOptions.filter(opt => opt.value === policyFloodSection?.nearestShoreTypeId)}
                        onChange={values => onFloodSectionFieldChange('nearestShoreTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.NEAREST_SHORE_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
            </Row>

            {/* Row 5 - Flood section fields */}
            <Row>
                <Column lg={3} md={3}>
                    <Select
                        id="elevatedFoundationTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.ELEVATION_FOUNDATION_TYPE}
                        options={elevatedFoundationTypeOptions}
                        defaultSelected={elevatedFoundationTypeOptions.filter(opt => opt.value === policyFloodSection?.elevatedFoundationTypeId)}
                        onChange={values => onFloodSectionFieldChange('elevatedFoundationTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.ELEVATION_FOUNDATION_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="elevatedMaterialTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.ELEVATED_MATERIAL_TYPE}
                        options={elevatedMaterialTypeOptions}
                        defaultSelected={elevatedMaterialTypeOptions.filter(opt => opt.value === policyFloodSection?.elevatedMaterialTypeId)}
                        onChange={values => onFloodSectionFieldChange('elevatedMaterialTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.ELEVATED_MATERIAL_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Select
                        id="enclosedForOtherPurposeTypeId"
                        tabIndex={tbIndex++}
                        label={cstPolicyUnderwritingLabel.ENCLOSED_FOR_OTHER_PURPOSE_TYPE}
                        options={enclosedForOtherPurposeTypeOptions}
                        defaultSelected={enclosedForOtherPurposeTypeOptions.filter(opt => opt.value === policyFloodSection?.enclosedForOtherPurposeTypeId)}
                        onChange={values => onFloodSectionFieldChange('enclosedForOtherPurposeTypeId', values[0])}
                        placeholder={cstPolicyUnderwritingLabel.ENCLOSED_FOR_OTHER_PURPOSE_TYPE}
                        showAsFloatingLabel={true}
                        className='mb-3'
                    />
                </Column>
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="enclosedFloorType" className="mb-3" label={cstPolicyUnderwritingLabel.ENCLOSED_FLOOR_TYPE}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="enclosedFloorType"
                            placeholder={cstPolicyUnderwritingLabel.ENCLOSED_FLOOR_TYPE}
                            value={policyFloodSection?.enclosedFloorType || ''}
                            onChange={e => onFloodSectionFieldChange('enclosedFloorType', e.currentTarget.value)}
                            isInvalid={formValidation[`enclosedFloorType_${policyFloodSection?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`enclosedFloorType_${policyFloodSection?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
            </Row>

            {/* Row 6 - enclosedSize + first 3 checkboxes (vertically centered) */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <FloatingLabel controlId="enclosedSize" className="mb-3" label={cstPolicyUnderwritingLabel.ENCLOSED_SIZE}>
                        <Form.Control
                            type="text"
                            tabIndex={tbIndex++}
                            name="enclosedSize"
                            placeholder={cstPolicyUnderwritingLabel.ENCLOSED_SIZE}
                            value={policyFloodSection?.enclosedSize || ''}
                            onChange={e => onFloodSectionFieldChange('enclosedSize', e.currentTarget.value)}
                            isInvalid={formValidation[`enclosedSize_${policyFloodSection?.id}`]?.isValid === false}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formValidation[`enclosedSize_${policyFloodSection?.id}`]?.warningText}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Column>
                <Column lg={3} md={3} className="d-flex align-items-center">
                    <Checkbox
                        id='isPrimaryResident'
                        className="checkbox-primary-resident"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.PRIMARY_RESIDENT}
                        checked={policyFlood?.isPrimaryResident || false}
                        onChange={() => onFloodFieldChange('isPrimaryResident', !policyFlood?.isPrimaryResident)}
                    />
                </Column>
                <Column lg={3} md={3} className="d-flex align-items-center">
                    <Checkbox
                        id='isCourseOf Construction'
                        className="checkbox-course-construction"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.COURSE_OF_CONSTRUCTION}
                        checked={policyFlood?.isCourseOfConstruction || false}
                        onChange={() => onFloodFieldChange('isCourseOfConstruction', !policyFlood?.isCourseOfConstruction)}
                    />
                </Column>
                <Column lg={3} md={3} className="d-flex align-items-center">
                    <Checkbox
                        id='isOwnedByState'
                        className="checkbox-owned-by-state"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.OWNED_BY_STATE}
                        checked={policyFlood?.isOwnedByState || false}
                        onChange={() => onFloodFieldChange('isOwnedByState', !policyFlood?.isOwnedByState)}
                    />
                </Column>
            </Row>

            {/* Row 7 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isCondoCoverageForUnit'
                        className="checkbox-condo-coverage"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.CONDO_COVERAGE_FOR_UNIT}
                        checked={policyFlood?.isCondoCoverageForUnit || false}
                        onChange={() => onFloodFieldChange('isCondoCoverageForUnit', !policyFlood?.isCondoCoverageForUnit)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isHighRise'
                        className="checkbox-high-rise"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HIGH_RISE}
                        checked={policyFlood?.isHighRise || false}
                        onChange={() => onFloodFieldChange('isHighRise', !policyFlood?.isHighRise)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isBldgElevated'
                        className="checkbox-bldg-elevated"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.BLDG_ELEVATED}
                        checked={policyFlood?.isBldgElevated || false}
                        onChange={() => onFloodFieldChange('isBldgElevated', !policyFlood?.isBldgElevated)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isContentHouseHold'
                        className="checkbox-content-household"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.CONTENT_HOUSE_HOLD}
                        checked={policyFlood?.isContentHouseHold || false}
                        onChange={() => onFloodFieldChange('isContentHouseHold', !policyFlood?.isContentHouseHold)}
                    />
                </Column>
            </Row>

            {/* Row 8 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isBldgFloodProof'
                        className="checkbox-flood-proof"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.BLDG_FLOOD_PROOF}
                        checked={policyFlood?.isBldgFloodProof || false}
                        onChange={() => onFloodFieldChange('isBldgFloodProof', !policyFlood?.isBldgFloodProof)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBasementEquip'
                        className="checkbox-basement-equip"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASEMENT_EQUIP}
                        checked={policyFloodSection?.hasBasementEquip || false}
                        onChange={() => onFloodSectionFieldChange('hasBasementEquip', !policyFloodSection?.hasBasementEquip)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentFurnace'
                        className="checkbox-base-furnace"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_FURNACE}
                        checked={policyFloodSection?.hasBaseEquipmentFurnace || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentFurnace', !policyFloodSection?.hasBaseEquipmentFurnace)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentWaterHeater'
                        className="checkbox-base-water-heater"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_WATER_HEATER}
                        checked={policyFloodSection?.hasBaseEquipmentWaterHeater || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentWaterHeater', !policyFloodSection?.hasBaseEquipmentWaterHeater)}
                    />
                </Column>
            </Row>

            {/* Row 9 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentElevator'
                        className="checkbox-base-elevator"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_ELEVATOR}
                        checked={policyFloodSection?.hasBaseEquipmentElevator || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentElevator', !policyFloodSection?.hasBaseEquipmentElevator)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentHeatPump'
                        className="checkbox-base-heat-pump"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_HEAT_PUMP}
                        checked={policyFloodSection?.hasBaseEquipmentHeatPump || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentHeatPump', !policyFloodSection?.hasBaseEquipmentHeatPump)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentFuelTank'
                        className="checkbox-base-fuel-tank"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_FUEL_TANK}
                        checked={policyFloodSection?.hasBaseEquipmentFuelTank || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentFuelTank', !policyFloodSection?.hasBaseEquipmentFuelTank)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentWasherDryer'
                        className="checkbox-base-washer-dryer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_WASHER_DRYER}
                        checked={policyFloodSection?.hasBaseEquipmentWasherDryer || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentWasherDryer', !policyFloodSection?.hasBaseEquipmentWasherDryer)}
                    />
                </Column>
            </Row>

            {/* Row 10 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentAirConditioner'
                        className="checkbox-base-air-conditioner"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_AIR_CONDITIONER}
                        checked={policyFloodSection?.hasBaseEquipmentAirConditioner || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentAirConditioner', !policyFloodSection?.hasBaseEquipmentAirConditioner)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentCistern'
                        className="checkbox-base-cistern"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_CISTERN}
                        checked={policyFloodSection?.hasBaseEquipmentCistern || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentCistern', !policyFloodSection?.hasBaseEquipmentCistern)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentFoodFreezer'
                        className="checkbox-base-food-freezer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_FOOD_FREEZER}
                        checked={policyFloodSection?.hasBaseEquipmentFoodFreezer || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentFoodFreezer', !policyFloodSection?.hasBaseEquipmentFoodFreezer)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasBaseEquipmentOther'
                        className="checkbox-base-other"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_BASE_EQUIPMENT_OTHER}
                        checked={policyFloodSection?.hasBaseEquipmentOther || false}
                        onChange={() => onFloodSectionFieldChange('hasBaseEquipmentOther', !policyFloodSection?.hasBaseEquipmentOther)}
                    />
                </Column>
            </Row>

            {/* Row 11 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isGarageAttached'
                        className="checkbox-garage-attached"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.IS_GARAGE_ATTACHED}
                        checked={policyFloodSection?.isGarageAttached || false}
                        onChange={() => onFloodSectionFieldChange('isGarageAttached', !policyFloodSection?.isGarageAttached)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentFurnace'
                        className="checkbox-garage-furnace"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_FURNACE}
                        checked={policyFloodSection?.hasGarageEquipmentFurnace || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentFurnace', !policyFloodSection?.hasGarageEquipmentFurnace)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentWaterHeater'
                        className="checkbox-garage-water-heater"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_WATER_HEATER}
                        checked={policyFloodSection?.hasGarageEquipmentWaterHeater || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentWaterHeater', !policyFloodSection?.hasGarageEquipmentWaterHeater)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentElevator'
                        className="checkbox-garage-elevator"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_ELEVATOR}
                        checked={policyFloodSection?.hasGarageEquipmentElevator || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentElevator', !policyFloodSection?.hasGarageEquipmentElevator)}
                    />
                </Column>
            </Row>

            {/* Row 12 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentHeatPump'
                        className="checkbox-garage-heat-pump"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_HEAT_PUMP}
                        checked={policyFloodSection?.hasGarageEquipmentHeatPump || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentHeatPump', !policyFloodSection?.hasGarageEquipmentHeatPump)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentFuelTank'
                        className="checkbox-garage-fuel-tank"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_FUEL_TANK}
                        checked={policyFloodSection?.hasGarageEquipmentFuelTank || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentFuelTank', !policyFloodSection?.hasGarageEquipmentFuelTank)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentWasherDryer'
                        className="checkbox-garage-washer-dryer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_WASHER_DRYER}
                        checked={policyFloodSection?.hasGarageEquipmentWasherDryer || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentWasherDryer', !policyFloodSection?.hasGarageEquipmentWasherDryer)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentAirConditioner'
                        className="checkbox-garage-air-conditioner"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_AIR_CONDITIONER}
                        checked={policyFloodSection?.hasGarageEquipmentAirConditioner || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentAirConditioner', !policyFloodSection?.hasGarageEquipmentAirConditioner)}
                    />
                </Column>
            </Row>

            {/* Row 13 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentCistern'
                        className="checkbox-garage-cistern"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_CISTERN}
                        checked={policyFloodSection?.hasGarageEquipmentCistern || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentCistern', !policyFloodSection?.hasGarageEquipmentCistern)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentFoodFreezer'
                        className="checkbox-garage-food-freezer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_FOOD_FREEZER}
                        checked={policyFloodSection?.hasGarageEquipmentFoodFreezer || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentFoodFreezer', !policyFloodSection?.hasGarageEquipmentFoodFreezer)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasGarageEquipmentOther'
                        className="checkbox-garage-other"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_GARAGE_EQUIPMENT_OTHER}
                        checked={policyFloodSection?.hasGarageEquipmentOther || false}
                        onChange={() => onFloodSectionFieldChange('hasGarageEquipmentOther', !policyFloodSection?.hasGarageEquipmentOther)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquip'
                        className="checkbox-elevated-equip"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIP}
                        checked={policyFloodSection?.hasElevatedEquip || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquip', !policyFloodSection?.hasElevatedEquip)}
                    />
                </Column>
            </Row>

            {/* Row 14 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentFurnace'
                        className="checkbox-elevated-furnace"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_FURNACE}
                        checked={policyFloodSection?.hasElevatedEquipmentFurnace || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentFurnace', !policyFloodSection?.hasElevatedEquipmentFurnace)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentWaterHeater'
                        className="checkbox-elevated-water-heater"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_WATER_HEATER}
                        checked={policyFloodSection?.hasElevatedEquipmentWaterHeater || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentWaterHeater', !policyFloodSection?.hasElevatedEquipmentWaterHeater)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentElevator'
                        className="checkbox-elevated-elevator"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_ELEVATOR}
                        checked={policyFloodSection?.hasElevatedEquipmentElevator || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentElevator', !policyFloodSection?.hasElevatedEquipmentElevator)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentHeatPump'
                        className="checkbox-elevated-heat-pump"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_HEAT_PUMP}
                        checked={policyFloodSection?.hasElevatedEquipmentHeatPump || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentHeatPump', !policyFloodSection?.hasElevatedEquipmentHeatPump)}
                    />
                </Column>
            </Row>

            {/* Row 15 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentFuelTank'
                        className="checkbox-elevated-fuel-tank"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_FUEL_TANK}
                        checked={policyFloodSection?.hasElevatedEquipmentFuelTank || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentFuelTank', !policyFloodSection?.hasElevatedEquipmentFuelTank)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentWasherDryer'
                        className="checkbox-elevated-washer-dryer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_WASHER_DRYER}
                        checked={policyFloodSection?.hasElevatedEquipmentWasherDryer || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentWasherDryer', !policyFloodSection?.hasElevatedEquipmentWasherDryer)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentAirConditioner'
                        className="checkbox-elevated-air-conditioner"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_AIR_CONDITIONER}
                        checked={policyFloodSection?.hasElevatedEquipmentAirConditioner || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentAirConditioner', !policyFloodSection?.hasElevatedEquipmentAirConditioner)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentCistern'
                        className="checkbox-elevated-cistern"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_CISTERN}
                        checked={policyFloodSection?.hasElevatedEquipmentCistern || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentCistern', !policyFloodSection?.hasElevatedEquipmentCistern)}
                    />
                </Column>
            </Row>

            {/* Row 16 - checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentFoodFreezer'
                        className="checkbox-elevated-food-freezer"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_FOOD_FREEZER}
                        checked={policyFloodSection?.hasElevatedEquipmentFoodFreezer || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentFoodFreezer', !policyFloodSection?.hasElevatedEquipmentFoodFreezer)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='hasElevatedEquipmentOther'
                        className="checkbox-elevated-other"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.HAS_ELEVATED_EQUIPMENT_OTHER}
                        checked={policyFloodSection?.hasElevatedEquipmentOther || false}
                        onChange={() => onFloodSectionFieldChange('hasElevatedEquipmentOther', !policyFloodSection?.hasElevatedEquipmentOther)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isElevatedMaterial'
                        className="checkbox-elevated-material"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.IS_ELEVATED_MATERIAL}
                        checked={policyFloodSection?.isElevatedMaterial || false}
                        onChange={() => onFloodSectionFieldChange('isElevatedMaterial', !policyFloodSection?.isElevatedMaterial)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isEnclosedFloor'
                        className="checkbox-enclosed-floor"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.IS_ENCLOSED_FLOOR}
                        checked={policyFloodSection?.isEnclosedFloor || false}
                        onChange={() => onFloodSectionFieldChange('isEnclosedFloor', !policyFloodSection?.isEnclosedFloor)}
                    />
                </Column>
            </Row>

            {/* Row 17 - Last 2 checkboxes */}
            <Row className="mb-3">
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isEnclosedWithOpening'
                        className="checkbox-enclosed-with-opening"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.IS_ENCLOSED_WITH_OPENING}
                        checked={policyFloodSection?.isEnclosedWithOpening || false}
                        onChange={() => onFloodSectionFieldChange('isEnclosedWithOpening', !policyFloodSection?.isEnclosedWithOpening)}
                    />
                </Column>
                <Column lg={3} md={3}>
                    <Checkbox
                        id='isEnclosedWithAreaFinished'
                        className="checkbox-enclosed-area-finished"
                        tabIndex={(tbIndex++).toString()}
                        label={cstPolicyUnderwritingLabel.IS_ENCLOSED_WITH_AREA_FINISHED}
                        checked={policyFloodSection?.isEnclosedWithAreaFinished || false}
                        onChange={() => onFloodSectionFieldChange('isEnclosedWithAreaFinished', !policyFloodSection?.isEnclosedWithAreaFinished)}
                    />
                </Column>
            </Row>
        </div>
    );
};

export default CustomerEditPolicyFloodUnderwriting;
